import * as React from "react";
import { RxFormField } from "../../rx-form";
import KeyValuePair from "../../utils/KeyValuePair";
import ComboBoxSelection from "./ComboBoxSelection";
import CheckBoxSelection from "./CheckBoxSelection";

export interface SelectionProps extends RxFormField {
    variant: 'combobox' | 'checkbox';
    autoFocus?: boolean;
    fullWidth?: boolean;
    items?: KeyValuePair<number | string, string>[];
    singleSelect?: boolean;
}

class Selection extends React.PureComponent<SelectionProps> {

    render() {
        switch (this.props.variant) {
            case 'combobox': return <ComboBoxSelection {...this.props} />;
            default: return <CheckBoxSelection {...this.props} />
        }
    }
}

export default Selection;
